import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Grid,
} from "@mui/material";

const DynamicForm = (props) => {
  const { data } = props;

  const formFields = [
    {
      label: "Url",
      type: "text",
      placeholder: "Please enter your URL...",
      name: "url",
    },
    {
      type: "file",
      placeholder: "",
      name: "logo",
    },
    {
      label: "data 1",
      type: "text",
      placeholder: "Please enter your data",
      name: "data",
    },
    {
      label: "data",
      type: "dropdown",
      name: "dtaa",
      options: [
        { label: "Free", value: "free" },
        { label: "Basic", value: "basic" },
        { label: "Premium", value: "premium" },
      ],
    },
    {
      label: "data 2",
      type: "text",
      placeholder: "Please enter your data 2",
      name: "data_2",
    },
    {
      label: "data 3",
      type: "text",
      placeholder: "Please enter your data 3",
      name: "data_3",
    },
    {
      label: "data 4",
      type: "text",
      placeholder: "Please enter your data 4",
      name: "data_4",
    },
    {
      label: "data 5",
      type: "text",
      placeholder: "Please enter your data 5",
      name: "data_5",
    },
  ];

  const [formData, setFormData] = useState({
    url: "",
    logo: "",
    data: "",
    dtaa: "",
    data_2: "",
    data_3: "",
    data_4: "",
    data_5: "",
  });

  // Use useEffect to populate the form data when props change
  useEffect(() => {
    if (data) {
      setFormData({
        url: data?.url || "",
        logo: data?.logo || "",
        data: data?.firstName || "",
        dtaa: data?.lastName || "",
        data_2: data?.age || 0,
        data_3: data?.data_3 || "",
        data_4: data?.data_4 || "",
        data_5: data?.data_5 || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <Box>
      <form onSubmit={handleSubmit} className="m-5">
        <Grid container spacing={2}>
          {formFields.map((field, index) => (
            <Grid item xs={12} sm={6} key={index}>
              {field.type === "dropdown" ? (
                <FormControl fullWidth>
                  <InputLabel>{field.label}</InputLabel>
                  <Select
                    label={field.label}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                  >
                    {field.options.map((option, idx) => (
                      <MenuItem key={idx} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  fullWidth
                  type={field.type}
                  label={field.label}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  onChange={handleChange}
                  variant="outlined"
                />
              )}
            </Grid>
          ))}
        </Grid>
        <Box mt={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            className="d-flex justify-content-end"
          >
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default DynamicForm;
